export const sortOrderType = {
  ASC: 1,
  DESC: 2
};

export enum moveSortOrderType {
  UP,
  DOWN
}
